import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Banner = ({ content, hasBrand = false }) => {
    return (
        <>
            <div className={styles.banner}>
                <div className={styles.brandBox}>
                    <img
                        className={styles.fengIcon}
                        src="https://x0.ifengimg.com/ucms/2022_47/A1AACF0B13B31F3525E84E1FC3193AFE62B77951_size23_w700_h56.png"
                    />
                    {hasBrand && (
                        <img
                            className={styles.zggdIcon}
                            src="https://x0.ifengimg.com/ucms/2022_47/19CA3CD585F4B1B089653A6C8DF8F4EE64628BEA_size10_w300_h56.png"
                        />
                    )}
                </div>
                <img className={styles.logoPic} src={content} />
            </div>
            <img
                className={styles.pageBg}
                src="https://x0.ifengimg.com/ucms/2022_47/3E43B17C8B9529F897DAF3AB019F45232D3191DA_size337_w5120_h3168.png"
            />
        </>
    );
};

Banner.propTypes = {
    content: PropTypes.string,
    hasBrand: PropTypes.bool,
};

export default errorBoundary(Banner);
